const lan = {
  REDIRECT: "Redirecionar...",
  RULE: {
    SERVICE_TYPE: "Selecione o tipo de serviço",
    COUNTRY: "Selecione seu país ou região",
    USERNAME: "É necessário um nome de usuário",
    EMAIL: "É necessário um nome de e-mail",
    EMAIL2: "Por favor, insira o formato de e-mail correto.",
    PRODUCT: "Selecione seu dispositivo",
    PRODUCTSN: "Por favor, insira o número de série do seu produto",
    PRODUCTSN_LEN: "Por favor, insira de 12 a 15 letras ou números",
    BIRTHDAY: "É necessário uma data de nascimento",
    REQUIRED: "Obrigatório",
  },
  SYS: {
    HEAD: "Sistema",
    NOSERVICE:
      "Desculpe, o serviço de bate-papo ASUS para o país ou região selecionado não está disponível.",
    CHECK_FILESIZE:
      "Por favor, verifique o tamanho da imagem ou do anexo do arquivo. Limite:",
    RECONNECTED: "O status da conexão voltou ao normal",
    UNABLE_SEND: "Não é possível enviar os anexos",
    NO_NETWORK: "Sem conexão com a internet",
    NO_NETWORK_INFO:
      "Sem conexão com a internet. Verifique sua conexão de rede e tente novamente.",
  },
  IDLE: {
    HEAD:
      "Você ficou inativo por um tempo. Gostaria de continuar a sessão de bate-papo?",
    BUTTON: "Continuar",
  },
  DISCONNECT: {
    HEAD: "A sessão de bate-papo terminou",
    BUTTON: "Terminar o bate-papo",
  },
  LAYOUT: {
    STEP_1: "Selecione o produto",
    STEP_2: "Termos de serviço",
    STEP_3: "Login",
    STEP_4: "Informações",
    SELECT_SKILL: "Selecione o produto",
    PREV_STEP: "Anterior",
    NEXT_STEP: "Próximo",
    NOTSET: "Não definido.",
    AGREEN: "Concordo",
    NOTAGREEN: "Discordo",
    LEAVE: "Sair",
    TYPE_HERE: "Digite aqui",
    CHAT_DOWNLOAD:
      "Clique aqui para salvar uma cópia do seu bate-papo com o serviço de bate-papo on-line da ASUS.",
  },
  COUNTRY: { SELECT_COUNTRY: "Selecione o país ou região do serviço" },
  POLICY: {
    PRIVACY: "Política de Proteção de Privacidade",
    SAT_SURVEY: "Contrato de Serviço",
    CONFIRM_COUNTRY: {
      H1: "Prezado Cliente da ASUS,",
      P1:
        "Agora você está visitando o ASUS Online Chat Service para a América do Norte, que é diferente da sua região atual. De acordo com os Termos de Garantia da ASUS, nem todo produto ASUS é aplicável ao serviço de Garantia e Suporte Internacional da ASUS. Se o site regional acima que você está visitando não for a região onde você comprou seu produto ASUS ou for diferente da sua região atual, isso pode afetar seus direitos. Você pode continuar usando o ASUS Online Chat Service para a América do Norte ou alterar o ASUS Online Chat Service para sua região.",
      P2: "",
      P3: "",
      B1: "Mudar para ASUS",
      B2: "Site",
      B3: "Continuar a usar",
    },
    BULLETIN: {
      HEAD: "Notificação de uma mensagem importante",
      CONFIRM: "Entendi",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Preencha suas informações de contato",
    SURVEY_TYPE: "Selecione o tipo de serviço",
    PROBLEM_BRIEF: "Como você descreveria seu problema?",
    TYPE1: "Pergunta geral",
    TYPE2: "Perguntas de suporte sobre reparos antes/em andamento",
    TYPE3: "Suporte técnico",
    TYPE4: "Consulta de garantia",
    TYPE5: "Perguntas de suporte pós-reparo",
    EC_TYPE1: "Informações sobre produtos e vendas",
    EC_TYPE2: "Status do pedido e envio",
    EC_TYPE3: "Devoluções",
    EC_TYPE4: "Outro",
    SIGNUPDATA: "Primeiro e Último Nome",
    NAME: "Nome",
    TEL: "Número de telefone",
    ORDER_NO: "Nº do pedido.",
    BIRTHDAY: "Aniversário",
    LABEL_EMAIL: "E-mail",
    EMAIL: "E-mail",
    DEVICEINFO: "Informações sobre o seu produto",
    DEVICENAME: "Nome do produto",
    MY_DEVICE: "Seu produto",
    MY_DEVICE_SELECT: "Selecione seu produto",
    MY_DEVICE_EMPTY: "Você ainda não tem nenhum dispositivo.",
    LABEL_DEVICESN: "Número de série",
    DEVICESN: "Número de série do produto",
    DEVICESN_ERROR: "O número de série que você digitou é inválido.",
    PREPARE: "Criando a sala de bate-papo, preparando-se para o bate-papo",
    START: "Iniciar o bate-papo",
    AGE_LIMIT: "Limite de idade",
    AGE_LIMIT_DESC:
      "Você não atende aos requisitos de idade para usar o ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Sala de bate-papo existente detectada",
      P1:
        "Tem certeza de que deseja iniciar uma nova conversa? Quando uma nova conversa é iniciada, a conversa antiga será encerrada.",
      B0: "Confirmar",
      B1: "Cancelar",
    },
  },
  CONNECTTING: {
    P1: "Aguarde um momento e não feche a janela de bate-papo",
    P2: "O bate-papo ASUS está conectando você a um agente disponível",
    NOTE: "Dica",
    BEFORE_LEAVE: "Tem certeza de que deseja encerrar seu bate-papo ASUS?",
    B0: "Finalizar o bate-papo",
    B1: "Fique e aguarde",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Entre em contato com a ASUS por outros canais",
    MAIL: "Envie-nos um e-mail",
    TEL: "Ligue para nós",
    CLOSE: "Fechar",
  },
  WAITTING: {
    WATTING_NUM: "Posição na fila",
    PEOPLE: "Cliente",
    NOTE: "Dica",
    BEFORE_LEAVEL: "Tem certeza de que deseja sair da fila?",
    LEAVE_DESC: "Se quiser sair da fila, você pode encerrar o Chat",
    LEAVE: "Encerrar o Chat",
    STAY: "Permanecer na fila",
  },
  CHATROOM: {
    TYPING: "O agente está digitando...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Sair do Chat",
      TERMINATE: "Finalizar o chat",
    },
    FOOTER: { CHAT_FINISH: "A sessão de chat terminou" },
    FINISH:
      "A sessão de chat terminou. Você precisa de algum serviço ou suporte adicional?",
    SAT_SURVEY: {
      SAT: "Satisfeito",
      DISSAT: "Insatisfeito",
      SAT_CHOOSE: "Que tipo de serviços? (vários)",
      HEAD: "Você ficou satisfeito com o serviço de bate-papo?",
      DESC:
        "Ouvir seu feedback é uma força motriz para nossa melhoria contínua. Por favor, deixe-nos saber se você tem alguma sugestão para o serviço ou suporte da ASUS.",
      OTHER_OPTION: "Outro",
      OTHER_REASON: "Por favor, preencha o outro motivo",
      SEND: "Enviar",
    },
    CLOSE: {
      TITLE: "Tem certeza de que deseja encerrar o bate-papo?",
      P1:
        "'Clique em 'Concluir' para fechar a sessão. Se você precisar conversar novamente, clique em 'Iniciar novo bate-papo'.",
      B0: "Encerrar bate-papo",
      B1: "Cancelar",
    },
  },
  ERROR: {
    H1: "A sala de bate-papo não existe ou o bate-papo já terminou",
    CLOSE: "Fechar a sessão",
  },
  CHAT_END: {
    H1: "Muito obrigado, o chat já terminou",
    CLOSE: "Fechar a sessão",
  },
  CHAT_CLOSE: {
    H1:
      "Sua rede está inativa há mais de 300 segundos, então encerramos esta sessão de bate-papo.",
    DESC:
      "Se você estiver usando uma rede sem fio ou móvel, vá para um local com sinal mais forte ou mude para uma conexão com fio. Lamentamos qualquer inconveniente",
    CLOSE: "Fechar a sessão",
  },
  SURVEY_DONE: {
    H1:
      "Obrigado pelo seu feedback. Você concluiu a Pesquisa de Satisfação do Serviço",
    P1:
      'Seu feedback é uma força motriz para nossa melhoria contínua. Obrigado por reservar um tempo para concluir a Pesquisa de Satisfação de Serviço. Se precisar de Serviço ou Suporte adicional, clique em "Iniciar novo Chat". Clique em "Fechar a sessão" para finalizar o Chat se tivermos resolvido sua consulta',
    AGAIN: "Iniciar um novo bate-papo",
    CLOSE: "Fechar a sessão",
    YT_H1: "Discover tips and tech know-how with ASUS support videos.",
    YT_H2: "Click to explore!",
  },
  AGENT_OFFLINE: {
    H1:
      "Lamentamos, parece que a conexão de internet do agente não está respondendo. Sua sessão de Chat está temporariamente interrompida. Aguarde enquanto tentamos resolver.",
    H2:
      "Por favor, não feche esta sessão. Estamos trabalhando duro para retomar a sessão de bate-papo para sua conveniência.",
    DESC:
      "'Você também pode escolher encerrar a sessão de Chat e começar a Pesquisa, ou clicar em 'Iniciar novo Chat' e imediatamente atribuiremos um novo agente para continuar seu Chat. Pedimos desculpas por qualquer inconveniente causado",
    AGAIN: "Iniciar um novo bate-papo",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Não é possível usar a câmera e o microfone",
    H1: "Pronto para começar?",
    P1:
      "Para que a equipe de atendimento ao cliente da ASUS possa ajudá-lo a resolver o problema de forma mais eficiente, você deve permitir que o dispositivo acesse sua câmera e microfone para entrar na sala de bate-papo por vídeo e certifique-se de que sua conexão de rede móvel esteja estável e funcionando normalmente",
    P2:
      "Após o acesso, você ainda pode definir livremente o interruptor da lente e o microfone mudo.",
    VIDEO_STATE: "Status do vídeo",
    VIDEO_ON: "Ligado",
    VIDEO_OFF: "Desligado",
    AUDIO_STATE: "Status do áudio",
    AUDIO_ON: "Ligado",
    AUDIO_OFF: "Desligado",
    ENTER: "Entrar",
    HANGUP: {
      H1: "Desligar",
      P1: "Tem certeza de que deseja desligar o chat de vídeo?",
      CONFIRM: "Confirmar",
      CANCEL: "Cancelar",
    },
    END: {
      H1: "A videochamada terminou",
      P1: "Obrigado, este chat de vídeo acabou, você pode fechar esta sessão.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Selecione o produto",
      STEP_2: "Termos de serviço",
      STEP_3: "Login",
      STEP_4: "Informações",
      SELECT_SKILL: "Selecione o produto",
      WELCOME: "Bem-vindo",
      AGREE: "Concordo",
      START: "Iniciar",
      CANCEL: "Cancelar",
      WAIT: "Por favor, aguarde.",
      INPUT: "Digite sua pergunta aqui",
      TRANSFER_TOAGENT: "Transferir para o agente.",
      READMORE:
        "Você pode consultar também a FAQ para mais detalhes, obrigado.",
      COLLAPSE: "Ocultar",
      INPUT_SN: "Digite novamente o número de série",
      YOU_MAY_ALSO: "Você também pode perguntar:",
      FOR_FURTHER: "Para mais informações, consulte",
      RECORDING: "Por favor comece a falar...",
      RECORDING_NOT_SUPPORTED:
        "Seu navegador não suporta reconhecimento de fala",
      RECORDING_NOT_FOUND:
        "Nenhum dispositivo de gravação detectado. Verifique seu microfone e permissões.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "Tipo de produto",
      MODEL: "Nome do produto",
      SERIALNO: "Número de série do produto",
      STATUS: "Status da garantia",
      DATE: "Data de vencimento da garantia",
    },
    HEAD: {
      LEAVE: "Sair",
      CREATE_NEW: "Recomeçar",
    },
    ENTRANCE: {
      POLICY: "Política de privacidade",
      AGREE:
        "Ao clicar em Iniciar, você concorda com a Política de Privacidade da ASUS.",
    },
    MESSAGE: {
      WAIT:
        "Por favor, aguarde um momento para reunir mais informações, retornarei em breve!",
    },
    END: "Conversa encerrada",
    END_MSG:
      "Obrigado por escolher a ASUS e espero que tenha um dia maravilhoso!",
    END_SURVEY: "Pesquisa de Satisfação",
    END_SURVEY_MSG:
      "Obrigado por escolher a ASUS e espero que você tenha um dia maravilhoso!",
    BACKHOME: "Reiniciar conversa",
    SURVEY: {
      DESC:
        "Por favor, classifique sua experiência com o assistente virtual ASUS.",
      SAT: "Satisfeito",
      DISSAT: "Insatisfeito",
      FEEDBACK: "Por favor, preencha seu feedback.",
      SEND: "Enviar",
      BACK: "Cancelar",
    },
    SURVEY_DISLIKE: {
      H1: "Por que você está insatisfeito com a resposta?",
      P: "Seu feedback nos ajuda a melhorar a qualidade do nosso serviço.",
      BUTTON: "Enviar",
    },
    HISTORY: {
      TITLE: "History",
      AGO: "{hours} hours ago",
      CONTINUE: "Continue Chat",
      CLOSE: "The conversation has been closed.",
      RESTART: "Restart with Virtual Assistant",
      NON_SERVICE: "Non-Service Hours",
      VIEW_HISTORY: "Click to view the latest chat history.",
    },
  },
};
export default lan;
